import { Edit, Eye, Trash } from "tabler-icons-react";

export const FAQHeaders = [
  { id: "id", numeric: true, disablePadding: true, label: "ID" },
  // {
  //   id: "faqCategory",
  //   numeric: false,
  //   disablePadding: true,
  //   label: "Category",
  // },

  //give full width to the question column
  {
    id: "faqQuestion",
    numeric: false,
    disablePadding: true,
    label: "Question",
  },
  {
    id: "faqAnswer",
    numeric: false,
    disablePadding: true,
    label: "Answer",
  },
  // {
  //   id: "state",
  //   numeric: false,
  //   disablePadding: true,
  //   label: "Status",
  // },
  {
    id: "actions",
    view: <Eye />,
    edit: <Edit />,
    delete: <Trash />,
    numeric: false,
    label: "Actions",
  },
];
